import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import type { PresenceUser } from '../../types';

interface PipelinePresenceProps {
  users: PresenceUser[];
  maxDisplay?: number;
}

/**
 * Active users presence indicator
 * Shows avatars of users currently viewing the pipeline
 */
export function PipelinePresence({ users, maxDisplay = 4 }: PipelinePresenceProps) {
  if (users.length === 0) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <span className="font-medium text-slate-600 dark:text-slate-300">Active now</span>
      <div className="flex -space-x-2">
        {users.slice(0, maxDisplay).map((person) => (
          <Tooltip key={`header-presence-${person.userId}`}>
            <TooltipTrigger asChild>
              <div
                className="h-6 w-6 rounded-full border border-white dark:border-slate-900 text-[10px] font-semibold text-white flex items-center justify-center shadow-sm"
                style={{ backgroundColor: person.color }}
              >
                {person.initials}
              </div>
            </TooltipTrigger>
            <TooltipContent side="top" align="center">
              {person.name}
            </TooltipContent>
          </Tooltip>
        ))}
        {users.length > maxDisplay && (
          <div className="h-6 w-6 rounded-full bg-slate-200 dark:bg-slate-700 text-[10px] font-semibold flex items-center justify-center text-slate-700 dark:text-slate-200 border border-white dark:border-slate-900">
            +{users.length - maxDisplay}
          </div>
        )}
      </div>
    </div>
  );
}
